/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TimeSeriesRecord } from './timeSeriesRecord';


export interface ColumnMetadata { 
    name?: string;
    unit?: string;
    records?: Array<TimeSeriesRecord>;
}

